import { useState } from 'react';
import clsx from 'clsx';
import { ExpensesList } from './components/expenses/ExpensesList.jsx';
import { RevenuesList } from './components/revenues/RevenuesList.jsx';
import { ExpenseCategoriesPanel } from './components/categories/ExpenseCategoriesPanel.jsx';
import { RevenueCategoriesPanel } from './components/categories/RevenueCategoriesPanel.jsx';

const TABS = [
  { key: 'expenses', label: 'المصاريف' },
  { key: 'revenues', label: 'الإيرادات' },
  { key: 'categories', label: 'الفئات' }
];

function Tabs({ value, onChange }) {
  return (
    <div className="inline-flex items-center gap-1 p-1 bg-white border border-line rounded-[10px] shadow-card">
      {TABS.map((t) => (
        <button
          key={t.key}
          type="button"
          onClick={() => onChange(t.key)}
          className={clsx(
            'px-3.5 py-1.5 rounded-[8px] text-[12.5px] font-semibold transition-colors',
            value === t.key
              ? 'bg-orange text-white shadow-orange-glow'
              : 'text-ink-2 hover:bg-paper-2'
          )}
        >
          {t.label}
        </button>
      ))}
    </div>
  );
}

export function FinanceScreen() {
  const [tab, setTab] = useState('expenses');

  return (
    <div className="flex flex-col gap-4">
      <div className="flex items-center justify-between flex-wrap gap-3">
        <div>
          <h2 className="text-xl font-extrabold tracking-tight m-0">المصاريف والإيرادات</h2>
          <div className="text-ink-3 text-xs mt-0.5">إدارة الإيرادات الإضافية والمصاريف اليومية</div>
        </div>
        <Tabs value={tab} onChange={setTab} />
      </div>

      {tab === 'expenses' ? <ExpensesList /> : null}
      {tab === 'revenues' ? <RevenuesList /> : null}
      {tab === 'categories' ? (
        <div className="grid gap-3.5" style={{ gridTemplateColumns: '1fr 1fr' }}>
          <ExpenseCategoriesPanel />
          <RevenueCategoriesPanel />
        </div>
      ) : null}
    </div>
  );
}
